import React from 'react'
import { t } from 'ttag'

import { DoubleConfirmationModal } from 'components/modals/DoubleConfirmationModal/DoubleConfirmationModal'
import { Modal } from 'components/shared/Modal/Modal'
import { MessageTemplateManagementForm } from './common/MessageTemplateManagementForm/MessageTemplateManagementForm'

import { useMessageTemplateManagementModalState } from './hooks'

import styles from './MessageTemplateManagementModal.module.scss'

export const MessageTemplateManagementModal = ({
  template,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const { state, handlers } = useMessageTemplateManagementModalState(
    { template, isOpen },
    { onCancel, onClose, onConfirm },
  )

  const {
    form: { control, formState },
    variables,
    isConfirmationOpen,
  } = state
  const {
    handleConfirmationClose,
    handleConfirmationConfirm,
    handleCancel,
    handleClose,
    handleConfirm,
  } = handlers

  return (
    <>
      <Modal
        className={styles.modal}
        cancelLabel={t`Cancel`}
        confirmLabel={t`Save`}
        title={template ? t`Edit message template` : t`Create message template`}
        onCancel={handleCancel}
        onClose={handleClose}
        onConfirm={handleConfirm}
        {...{ isOpen }}
      >
        <Modal.Header />
        <Modal.Content className={styles.content}>
          <MessageTemplateManagementForm
            {...{ control, formState, variables }}
          />
        </Modal.Content>
        <Modal.Footer />
      </Modal>
      <DoubleConfirmationModal
        onCancel={handleConfirmationClose}
        onClose={handleConfirmationClose}
        onConfirm={handleConfirmationConfirm}
        isOpen={isConfirmationOpen}
      />
    </>
  )
}
